export default ()=>{
    const openModalData = 'data-open-modal';
    const closeModalData = 'data-close-modal';
    // const body = document.body;
    const body = document.querySelector("html");
    const openModal = document.querySelectorAll(`[${openModalData}]`);
    const closeModal = document.querySelectorAll(`[${closeModalData}]`);

    openModal.forEach(function (item) {
        item.addEventListener('click', ()=>{
           body.classList.add('modal-form-active');
        });
    });

    closeModal.forEach(function (item) {
        item.addEventListener('click', ()=>{
           body.classList.remove('modal-form-active');
        });
    });


    //On load page show contact modal
    const onLoadPageData = 'data-contact-modal';
    const onLoadPage = document.querySelector(`[${onLoadPageData}]`);

    if (onLoadPage){
        setTimeout(() => {
            body.classList.add('modal-form-active');
        }, 5000);
    }
}